import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import { useGetAllViewsUrl } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AllViewsButton({
  isLoading,
  readOnly
}) {
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const allViewsUrl = useGetAllViewsUrl();
  const handleLinkClick = useCallback(() => {
    trackCrmTableInteraction({
      action: 'click-all-views-link'
    });
  }, [trackCrmTableInteraction]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "crm-listing-all-views-button",
    disabled: readOnly || isLoading,
    href: allViewsUrl,
    onClick: handleLinkClick,
    use: "transparent",
    children: isLoading ? /*#__PURE__*/_jsx(LoadingSkeleton, {
      blockSize: "16px",
      inlineSize: "90px"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.viewTabs.allViews"
    })
  });
}